/** Fallback article for every entitlement surface: "Why can't I use this feature?" (topic `access`). */
export const ENTITLEMENT_GUIDE_FALLBACK_SLUG = 'guide-access';

export type EntitlementGuideTopic = {
  /** Topic whose hub the link opens once it is published. */
  topic: string;
  /** Display name in the "How {featureName} works" wording. */
  featureName: string;
};

/**
 * Guide topic by `capability_name`. A capability without a row links only
 * through the fallback article; add a row when its hub is written (GDN-3682).
 */
export const ENTITLEMENT_GUIDE_TOPICS: Readonly<Record<string, EntitlementGuideTopic>> = {
  document_creation: { topic: 'documents', featureName: 'document generation' },
  lab_order_creation: { topic: 'labs', featureName: 'lab orders' },
  form_sending: { topic: 'forms', featureName: 'patient forms' },
  template_creation: { topic: 'templates', featureName: 'template creation' },
  in_note_training: { topic: 'training', featureName: 'in-note training' },
  note_creation: { topic: 'notes', featureName: 'note creation' },
  audit_suggestions: { topic: 'audit', featureName: 'JotAudit' },
  ehr_note_copy: { topic: 'ehr-extension', featureName: 'the EHR extension' },
};

export type EntitlementGuideTarget =
  | { topic: string; fallbackSlug: string; featureName: string }
  | { slug: string };

/** GuideLink target for a capability: its topic hub with the access article as fallback, or that article alone. */
export function entitlementGuideTarget(capabilityName?: string): EntitlementGuideTarget {
  const entry: EntitlementGuideTopic | undefined = capabilityName
    ? ENTITLEMENT_GUIDE_TOPICS[capabilityName]
    : undefined;
  return entry
    ? { ...entry, fallbackSlug: ENTITLEMENT_GUIDE_FALLBACK_SLUG }
    : { slug: ENTITLEMENT_GUIDE_FALLBACK_SLUG };
}
